import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared';

import { TransmissionReadingsComponent } from './transmission-readings.component';

@NgModule({
  declarations: [TransmissionReadingsComponent],
  imports: [CommonModule, SharedModule],
})
export class TransmissionReadingsModule {}
